import React from "react";

import CrewSignOffTable from "../components/operation/taskOff/CrewSignOffTable";
import { Box, Container, Grid } from "@mui/material";

const ClientOperationSignOffTask = () => {
  return (
    <>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{
          background: "#f4f4f4",
          paddingTop: "16px",
        }}
      >
        <Grid item xs={12} md={12}>
          <Container
            maxWidth="xl"
            sx={{
              bgcolor: "#fff",
              padding: "16px !important",
              borderRadius: "10px",
               width: "100%",
              minWidth: "100%",
            }}
          >
            <Box
              sx={{
                bgcolor: "#fff",
                height: { xs: "auto", sm: "100vh" },
                border: "1px solid #d1cfcf",
                borderRadius: "5px",
                padding: "16px",
                overflowY: "scroll",
                marginTop: "16px",
              }}
            >
              <CrewSignOffTable />
            </Box>
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

export default ClientOperationSignOffTask;
